var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4705_5246",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4705_5246)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.0385 17.5L4.0365 19.5018C3.752 19.7864 3.42475 19.8509 3.05475 19.6952C2.68492 19.5394 2.5 19.2589 2.5 18.8538V4.30775C2.5 3.80258 2.675 3.375 3.025 3.025C3.375 2.675 3.80258 2.5 4.30775 2.5H19.6923C20.1974 2.5 20.625 2.675 20.975 3.025C21.325 3.375 21.5 3.80258 21.5 4.30775V15.6923C21.5 16.1974 21.325 16.625 20.975 16.975C20.625 17.325 20.1974 17.5 19.6923 17.5H6.0385ZM5.4 16H19.6923C19.7693 16 19.8398 15.9679 19.9038 15.9038C19.9679 15.8398 20 15.7692 20 15.6923V4.30775C20 4.23075 19.9679 4.16025 19.9038 4.09625C19.8398 4.03208 19.7693 4 19.6923 4H4.30775C4.23075 4 4.16025 4.03208 4.09625 4.09625C4.03208 4.16025 4 4.23075 4 4.30775V17.3848L5.4 16ZM7 13.75H13C13.2128 13.75 13.391 13.6782 13.5345 13.5345C13.6782 13.391 13.75 13.2128 13.75 13C13.75 12.7872 13.6782 12.609 13.5345 12.4655C13.391 12.3218 13.2128 12.25 13 12.25H7C6.78717 12.25 6.609 12.3218 6.4655 12.4655C6.32183 12.609 6.25 12.7872 6.25 13C6.25 13.2128 6.32183 13.391 6.4655 13.5345C6.609 13.6782 6.78717 13.75 7 13.75ZM7 10.75H17C17.2128 10.75 17.391 10.6782 17.5345 10.5345C17.6782 10.391 17.75 10.2128 17.75 10C17.75 9.78717 17.6782 9.609 17.5345 9.4655C17.391 9.32183 17.2128 9.25 17 9.25H7C6.78717 9.25 6.609 9.32183 6.4655 9.4655C6.32183 9.609 6.25 9.78717 6.25 10C6.25 10.2128 6.32183 10.391 6.4655 10.5345C6.609 10.6782 6.78717 10.75 7 10.75ZM7 7.75H17C17.2128 7.75 17.391 7.67817 17.5345 7.5345C17.6782 7.391 17.75 7.21283 17.75 7C17.75 6.78717 17.6782 6.609 17.5345 6.4655C17.391 6.32183 17.2128 6.25 17 6.25H7C6.78717 6.25 6.609 6.32183 6.4655 6.4655C6.32183 6.609 6.25 6.78717 6.25 7C6.25 7.21283 6.32183 7.391 6.4655 7.5345C6.609 7.67817 6.78717 7.75 7 7.75Z",
    fill: "#495057"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.160c68152bd92a0bdfd3dadcc1acf1db.svg";
export { ForwardRef as ReactComponent };